module.exports = __webpack_public_path__ + "img/img-7.4fff6155.png";